import type { ComputeElementsBoundingBox } from "./types";

export const computeElementsBoundingBox: ComputeElementsBoundingBox = ({
  detectedObjects,
  circuitPaths,
}) => {
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  let hasAny = false;

  for (const detectedObject of detectedObjects) {
    const { x1, y1, x2, y2 } = detectedObject.bbox;
    if (x1 < minX) minX = x1;
    if (x2 > maxX) maxX = x2;
    if (y1 < minY) minY = y1;
    if (y2 > maxY) maxY = y2;
    hasAny = true;
  }

  for (const path of circuitPaths?.paths ?? []) {
    for (const waypoint of path.waypoints) {
      if (waypoint.x < minX) minX = waypoint.x;
      if (waypoint.x > maxX) maxX = waypoint.x;
      if (waypoint.y < minY) minY = waypoint.y;
      if (waypoint.y > maxY) maxY = waypoint.y;
      hasAny = true;
    }
  }

  if (circuitPaths?.distributionBoardPosition) {
    const { x, y } = circuitPaths.distributionBoardPosition;
    if (x < minX) minX = x;
    if (x > maxX) maxX = x;
    if (y < minY) minY = y;
    if (y > maxY) maxY = y;
    hasAny = true;
  }

  return hasAny ? { minX, minY, maxX, maxY } : null;
};
